module.exports = __webpack_public_path__ + "static/media/displayed-phones.eae3d792.jpg";